<template>
  <div class="child-layout">
    <Header />
    <div v-if="this.$mq != 'mobile'"
         class="sidebar">
      <Feed />
    </div>
    <div class="content"
         :class="contentClasses">
      <child-page-header class="child-page-header"
                         :child-id="$route.params.id"/>
      <child-navigation class="child-navigation"
                        :child-id="$route.params.id"/>

      <div class="slot">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
  import Header from '@/components/Header/Header.vue'
  import Feed from '@/components/Feed/Feed.vue'
  import ChildPageHeader from '@/components/Child/ChildPageHeader/ChildPageHeader.vue'
  import ChildNavigation from '@/components/Child/ChildNavigation/ChildNavigation.vue'

  export default {
    components: {
      Header,
      Feed,
      ChildPageHeader,
      ChildNavigation
    },

    computed: {
      contentClasses() {
        return {
          'content-mobile': this.$mq === 'mobile'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .child-layout {
    height: 100%;
  }

  .sidebar {
    position: fixed;
    top: $header-height;
    width: $sidebar-width;
    height: 100%;
    padding: 10px 0 0 20px;
    box-shadow: 2px 0 4px 0 rgba(0, 0, 0, 0.1);
    background-color: #fff;
    overflow: hidden;
  }

  .content {
    display: flex;
    flex-direction: column;
    padding: $header-height 0 0 $sidebar-width;
    min-height: 100%;
    height: 100%;

    .child-page-header,
    .child-navigation {
      flex-shrink: 0;
    }

    .slot {
      flex: 1 0;
      overflow: hidden;
    }
  }

  .content-mobile {
    padding: $header-height 0 0 0;
  }
</style>
